import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { FC, useEffect, useMemo } from 'react';
import breakpoints from '../../../constants/breakpoints.constants';
import { SocialMediaBarModel } from './models/socialMediaBar.model';
import { TSocialMediaBarProps } from './types/socialMediaBar.types';
import SocialLinks from './components/socialLinks';
import useEEActive from '../../../hooks/useEEActive';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { documentService, windowService } from '../../../utils/window.utils';
import './styles.scss';

const SocialMediaBar: FC<TSocialMediaBarProps & { extraClassName?: string }> = (props) => {
  const model = new SocialMediaBarModel(props);
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);
  const isEEactive = useEEActive();

  useEffect(() => {
    const a2a_config = windowService().a2a_config || {};
    a2a_config.templates = a2a_config.templates || {};

    function my_addtoany_onshare(data) {
      return {
        title: data.node.getAttribute('data-title') || '',
        url: data.node.getAttribute('data-is-page-url') ? windowService().location.href : '',
      };
    }

    a2a_config.callbacks = [];
    a2a_config.callbacks.push({
      share: my_addtoany_onshare,
    });

    windowService().a2a_config = a2a_config;
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const shareScript = 'https://static.addtoany.com/menu/page.js';
      const addthisScript = documentService()?.createElement?.('script');
      addthisScript.setAttribute('src', shareScript);
      const shareContentScript = documentService()?.querySelector?.(`[src="${shareScript}"]`);
      if (documentService()?.body && !shareContentScript) documentService()?.body?.appendChild?.(addthisScript);
      else windowService()?.a2a?.init_all?.();
    });
  }, []);

  const countValidSocialLinks = useMemo(() => {
    return (
      model.socialLinksItems?.filter(
        (item) => !!(isEEactive || (item?.fields?.icon?.fields?.iconKey?.value && item?.fields?.icon?.fields?.iconUrl?.value))
      ).length || 0
    );
  }, [model.socialLinksItems]);

  if (!isDesktop || countValidSocialLinks === 0) return null;
  return (
    <div className={`social-media-bar ${props.extraClassName || ''}`}>
      <div className="social-media-bar__social">
        {model?.socialText && <Text tag="div" className="social-media-bar__social-text" field={model?.socialText} />}
        <div className="social-media-bar__social-icons a2a_kit a2a_kit_size_32 a2a_default_style">
          <SocialLinks isEEactive={isEEactive} socialLinksItems={model.socialLinksItems} />
        </div>
      </div>
    </div>
  );
};

export default SocialMediaBar;
